import React, { useState } from "react";
import { changePassword } from "../../../services/MainApiDetails";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import Slide from "@mui/material/Slide";
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
const ChangePassword = () => {
    const [password, setPassword] = useState()
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState()
    const [confirmPassText, setConfirmPassText] = useState()
    const [error, setErrors] = useState()
    const [passwordSuccess, setPasswordSuccess] = useState()
    const handleOtpClose = () => {
        setPasswordSuccess(false);
    };

    function confirmPasswordFunc(e) {
        let val = e.target.value;


        if (password != val) {

            // setConfirmPassText("Password do not match");
        } else {
            // setConfirmPassText("Password do not match");
        }

        setConfirmPassword(val);
    }

    function changeUserPassword() {
        let email = null
        let phone = null
        let countryCode = ''

        if (localStorage.email) {
            email = localStorage.email
        }
        if (localStorage.phone) {
            phone = localStorage.phone
        }

        if (password && (password == confirmPassword)) {
            setConfirmPassText("");
            setErrors("")

            changePassword({
                phone: phone,
                email: email,
                country_code: localStorage.country_code,
                password: password,
                otp: localStorage.otp
            }).then(res => {

                if (res.data.status === 1) {
                    setPasswordSuccess(true)
                    localStorage.removeItem("email", localStorage.email)
                    localStorage.removeItem("phone", localStorage.phone)
                    localStorage.removeItem("country_code", localStorage.country_code)
                    localStorage.removeItem("otp", localStorage.otp)
                    setPasswordSuccess(true)
                    console.log(passwordSuccess)
                }
                else {
                    setErrors(res.data.message)
                }

            }).catch(e => {

            })
        }
        else {
            if (!password) {

                setErrors("Please enter password")
            }
            else if (password != confirmPassword) {
                setConfirmPassText("Password do not match");
            }
        }

    }
    function continueToLogin() {
        window.location.href = "/mobile-login"
    }
    return (
        <div className="mobileForgotPassword-form-wrapper">
            <div className="mobileForgotPassword-form-top">
                <h6>Change Password</h6>
            </div>
            <div className="mobileForgotPassword-form-bottom">
                <form action="">
                    <div className="mobileForgotPassword-input-wrapper">
                        <div className="mobileForgotPassword-inputBox">
                            <span>Enter Password</span>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Type here"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    style={{ width: '100%', paddingRight: '40px' }}
                                />
                                <span
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '100%',
                                        top: 0,
                                    }}>
                                    {showPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </span>
                            </div>
                            <span style={{ color: 'red' }}>{error}</span>
                        </div>
                        <div className="mobileForgotPassword-inputBox">
                            <span>Confirm Password</span>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                <input
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    placeholder="Type here"
                                    value={confirmPassword}
                                    onChange={confirmPasswordFunc}
                                    style={{ width: '100%', paddingRight: '40px' }}
                                />
                                <span
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: '10px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: '100%',
                                        top: 0,
                                    }}>
                                    {showConfirmPassword ? <Visibility fontSize="small" /> : <VisibilityOff fontSize="small" />}
                                </span>
                            </div>
                        </div>
                        <span style={{ "color": "red" }}>{confirmPassText}</span>

                    </div>

                    <div className="mobileForgotPassword-signup-button">
                        <button type="button" onClick={() => changeUserPassword()}>CHANGE PASSWORD</button>
                    </div>
                </form>
            </div>
            <div className="pleaseLoginModal">
                {/* <Button variant="outlined" onClick={handleClickOpen}>
          PLEASE LOG IN
        </Button> */}
                <Dialog
                    open={passwordSuccess}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={handleOtpClose}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <div className="pleaseLoginModal-wrapper">
                        <div className="pleaseLoginModal-header">
                            <h2>Password Reset Successfully</h2>
                        </div>

                        <div className="pleaseLoginModal-content">
                            <p>Please click <b>Login</b> to continue.</p>
                        </div>

                        <div className="pleaseLoginModal-button-wrapper">
                            {/* <Link to="/mobile-login"> */}
                            <Button onClick={continueToLogin} className="pleaseLoginModal-login-btn">Login</Button>
                            {/* </Link> */}
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    );
};

export default ChangePassword;
